import { FaExternalLinkAlt } from "react-icons/fa";
import { TbSettingsExclamation } from "react-icons/tb";
import { JSONTree } from "react-json-tree";

export default function AppSettingsTree({
    resolvedSettings,
    overrideSettings,
    url,
    className,
}) {
    const getValueAtPath = (obj, path) =>
        path.reduceRight(
            (acc, key) =>
                acc && acc[key] !== undefined ? acc[key] : undefined,
            obj,
        );

    return Object.keys(resolvedSettings).length > 0 ? (
        <div className={className}>
            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
            >
                <div className="small text-uppercase text-secondary fw-bold border-bottom border-3 mb-1">
                    App settings:
                    <FaExternalLinkAlt
                        className="ms-2"
                        style={{ marginTop: "-4px" }}
                    />
                </div>
            </a>

            <JSONTree
                data={resolvedSettings}
                hideRoot={true}
                sortObjectKeys={true}
                shouldExpandNodeInitially={() => true}
                invertTheme={true}
                theme={{
                    extend: "monokai",
                    tree: {
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontSize: "14px",
                        lineHeight: "1",
                    },
                    base0D: "#212529",
                    base00: "transparent",
                }}
                labelRenderer={(keyPath) => {
                    const label = keyPath[0];
                    const overrideValue = getValueAtPath(
                        overrideSettings,
                        keyPath,
                    );
                    const isOverridden = overrideValue !== undefined;

                    return (
                        <span
                            style={{ fontWeight: isOverridden ? "800" : "400" }}
                        >
                            {label}
                            {isOverridden && (
                                <TbSettingsExclamation className="ms-1" />
                            )}
                            :
                        </span>
                    );
                }}
            />
        </div>
    ) : (
        <div className="small text-muted">No app settings configured.</div>
    );
}
